import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, Flame } from 'lucide-react';
import { useAuth } from '../auth';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (isAuthenticated) navigate('/'); }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo"><Flame size={30} /></div>
          <h1>SiWa</h1>
          <p className="login-desc">Sicherheitswachen-Einteilung</p>
          <p className="login-desc">Feuerwehr</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message"><AlertCircle size={16} />{error}</div>
          )}
          <div className="form-group">
            <label>Benutzername</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Benutzername eingeben" required autoFocus />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passwort eingeben" required />
          </div>
          <button type="submit" className="btn btn-primary btn-lg login-btn" disabled={loading}>
            {loading ? 'Anmeldung…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
